import { pipe, prop } from 'ramda';

const selectAllBlogState = prop('blog');

export const selectCurrentPage = pipe(selectAllBlogState, prop('currentPage'));

export const selectIsInitialFetchDone = pipe(
  selectAllBlogState,
  prop('isInitialFetchDone')
);

export const selectIsLoading = pipe(selectAllBlogState, prop('isLoading'));

export const selectPosts = pipe(selectAllBlogState, prop('posts'));

export const selectHasMore = pipe(selectAllBlogState, prop('hasMore'));
